import React from 'react';
import { AboutUser } from 'modules/ranking/ranking-latam/_ecosystem/components/user/AboutUser';
import logoRanking from 'assets/images/logo-ranking-2022.svg';

import * as List from 'components/list';
import * as Page from 'components/page';

import { CG } from 'contexts/ContextGlobal';
import { NextStep } from './components/NextStep';
import { Pocs } from '../components/user/pocs';

const country = {
    pt: 'Brasil',
    en: 'Brazil',
    es: 'Brasil'
};

export const EcosystemIndexView = props => {
    const { state } = React.useContext(CG);

    return (
        <Page.Page
            name="EcosystemIndex"
            back="/ranking/latam"
            customBackText={props.t('glossary:backToRanking')}
        >
            <Page.Image>
                <img src={logoRanking} alt="Logo Ranking 100 Open Startups" width="40%" />
            </Page.Image>

            <Page.Title>
                {props.t('EcosystemIndex.title', { country: country[state.language] })}
            </Page.Title>
            <Page.Descr>{props.t('EcosystemIndex.descr')}</Page.Descr>

            <List.List name="EcosystemIndexSteps">
                <List.Steps items={props.steps} itemKey="step" />
            </List.List>

            <NextStep {...props} />

            <Page.Ruler type="dots" />

            <AboutUser />

            <Pocs {...props} />

            <List.List name="EcosystemIndexActions">
                <List.Vertical items={props.actions} itemKey="id" />
            </List.List>
        </Page.Page>
    );
};
export default EcosystemIndexView;
